import { hFetch } from '@/lib/hfetch';

export type LectureCompletionResponse = { lecture_id: number; completed_at?: string };

export const createLectureCompletion = async (lectureId: number) => {
  return await hFetch<LectureCompletionResponse, { lecture_id: number }>({
    url: '/api/agent/university_lecture_completions',
    method: 'POST',
    payload: { lecture_id: lectureId },
  });
};

export const deleteLectureCompletion = async (lectureId: number) => {
  return await hFetch<LectureCompletionResponse>({
    url: `/api/agent/university_lecture_completions/${lectureId}`,
    method: 'DELETE',
  });
};
